import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { api } from '../../services/apiService';
import styles from '../../styles/styles';

export default function UserEmailDisplay() {
  const { userInfo } = useAuth();
  const navigate = useNavigate();
  const isOperador = userInfo?.roleNome === 'Operador';

  return (
    <Box sx={{ ...styles.emailRow, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Typography variant="body2" sx={styles.emailText}>
        <AccountCircleIcon />{userInfo.email}
      </Typography>
      {isOperador && (
        <Tooltip title="Alterar linha">
          <IconButton
            size="small"
            onClick={async () => {
              await api.operadorLinha.liberar().catch(() => {});
              navigate('/operador-linha');
            }}
          >
            <SyncAltIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
}
